
import SeriesList from "@/components/video/seriesList/index"

import VideoPlayer from "@/components/video/videoPlayer/index"
import WistiaPlayer from "@/components/video/wistiaPlayer"

import VideoDis from "@/components/video/videoDis"
import VideoComments from "@/components/video/videoComments/main"

import "./style.css"
import { useAuthToken } from "@/hooks/useAppSelectors"
import { allQueryParam } from "@/constants/urlPaths"
import { addCurrentThemeClassToEle, hasQueryParam } from "@/utils"
import { commentsStatus } from "@/pages/watch/main/constants"
import { useSelector } from "react-redux"
import { RootState } from "@/store"

export default function WatchDesktopMainView(props: any) {
    const token = useAuthToken();
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);
    const currentVideoType = props.currentVideoObj?.videoType?.type;
    const isDefaultVideoPlayer = currentVideoType !== "wistia";
   console.log("videoprops",props)
    return (
        <div className={`flex watchDesktopMainView ${addCurrentThemeClassToEle(currentTheme, 'watchDesktopMainView')}`}>
            <div className={`lhsCon flex flex-col
                     ${(hasQueryParam(allQueryParam.series) && token) ? '' : 'lhsCon_isPublic'}`}>
                {/* ${!isPublicVideo(props.currentVideoObj) ? '' : 'lhsCon_isPublic'}`}> */}
                {isDefaultVideoPlayer ? (
                    <VideoPlayer
                        isLoading={props.isLoading}
                        playNextVideo={props.playNextVideo}
                        isWelcomeSeries={props.isWelcomeSeries}
                    />
                ) : (
                    <WistiaPlayer
                        isWelcomeSeries={props.isWelcomeSeries}
                        playNextVideo={props.playNextVideo}
                        title={props.currentVideoObj?.title || "Wistia video"}
                        containerClassName="wistiaIframeCon"
                    />
                )}
                
                <VideoDis
                    isLoading={props.isLoading}
                    currentVideoObj={props.currentVideoObj}
                    seriesNotes={props.seriesNotes}
                    isWelcomeSeries={props.isWelcomeSeries}
                    seriesId={props.seriesId}
                    isSubscribedSeries={props.isSubscribedSeries}
                    isPGCourseSeries={props.isPGCourseSeries}
                />

                {props.currentVideoObj
                    && props.currentVideoObj.commentsStatus
                    && props.currentVideoObj.commentsStatus !== commentsStatus.disabled ? (
                    <VideoComments
                        isLoading={props.isLoading}
                        currentVideoObj={props.currentVideoObj}
                        isWelcomeSeries={props.isWelcomeSeries}
                    />
                ) : (
                    <div className="h-[50px] invisible">
                        note : hide it to add extra space when comments are not there
                    </div>
                )
                }

            </div>


            <div className={`rhsCon bg-grayX-700 sticky h-[88vh] overflow-y-auto
                     ${(hasQueryParam(allQueryParam.series) && token) ? '' : 'rhsCon_isPublic'}`}>
                {/* ${!isPublicVideo(props.currentVideoObj) ? '' : 'rhsCon_isPublic'}`}> */}
                <SeriesList
                    seriesDetails={props.seriesDetails}
                    updateCurrentVideoObj={props.updateCurrentVideoObj}
                    isLoading={props.isLoading}
                    currentVideoObj={props.currentVideoObj}
                    videoChangingId={props.videoChangingId}
                    isWelcomeSeries={props.isWelcomeSeries}
                    
                />
            </div>
        </div>
    );
}
